import React, { useEffect, useRef } from 'react';
import Hls from 'hls.js';

type HlsMediaProps = React.AudioHTMLAttributes<HTMLAudioElement> &
  React.VideoHTMLAttributes<HTMLVideoElement> & {
    kind?: 'audio' | 'video';
    src?: string;
  };

export const attachHlsSource = (media: HTMLMediaElement, src: string): (() => void) => {
  if (!src.toLowerCase().includes('.m3u8')) {
    media.src = src;
    return () => undefined;
  }
  if (media.canPlayType('application/vnd.apple.mpegurl')) {
    media.src = src;
    return () => undefined;
  }
  if (!Hls.isSupported()) {
    media.src = src;
    return () => undefined;
  }
  const hls = new Hls();
  hls.loadSource(src);
  hls.attachMedia(media);
  return () => hls.destroy();
};

const HlsMedia: React.FC<HlsMediaProps> = ({ kind = 'audio', src = '', ...props }) => {
  const ref = useRef<HTMLMediaElement | null>(null);

  useEffect(() => {
    if (!ref.current || !src) return undefined;
    return attachHlsSource(ref.current, src);
  }, [src]);

  if (kind === 'video') {
    return <video ref={(node) => { ref.current = node; }} {...props} />;
  }
  return <audio ref={(node) => { ref.current = node; }} {...props} />;
};

export default HlsMedia;
